import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

import { NavController } from '@ionic/angular';
//Services
import { AuthGnxService } from "src/app/services/authGnx/auth-gnx.service";
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { AlertService } from "src/app/services/alert/alert.service";
import { RouterService } from "src/app/services/router/router.service";
import { Platform } from "@ionic/angular";

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.page.html',
  styleUrls: ['./forgot.page.scss'],
})
export class ForgotPage {
  forgotForm: FormGroup;
  submitted = false;
  validb = false;
  constructor(
    private formBuilder: FormBuilder,
    private authGnx: AuthGnxService,
    public alertService: AlertService,
    private navCtrl: NavController,
    public languageService: LanguagesService,
    private routerService: RouterService,
    public platform: Platform,
  ) {
    this.initConstructor();
  }

  private initConstructor() {
    
    if(this.platform.is("desktop")){
       this.validb = true
    }
    console.log(this.platform.is("desktop"));
    

    this.forgotForm = this.formBuilder.group({
      email: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$"),
        ]),
      ]
    });
  }

  sendLinkResetPassword() {
    this.submitted = true;
    this.alertService.show();
    this.authGnx.resetPassword(this.forgotForm.value.email).then(() => {
      this.alertService.hide();
      this.alertService.presentAlert(this.getTextsIUForgot.sendLinkText);
      this.navCtrl.back();
    }, error => {
      console.log(error);
      this.alertService.hide();
      this.alertService.showErrorAlert(this.getTextsIUForgot.sendLinkNoEmailError);
    }).catch(error => {
      console.log(error);
      this.alertService.hide();
      this.alertService.showErrorAlert(this.getTextsIUForgot.sendLinkError);
    });
  }

  get getTextsIUForgot() {
    return this.languageService.textsIU['page_forgot'];
  }

  get getInputError() {
    return this.languageService.textsIU.input_error;
  }

  redirectTo(){
    this.routerService.redirect(`login`);
  }

}
